const DiskSlider = Vue.component('disk-slider', {
    name: 'DiskSlider',
    template: '#disk-slider',
    props: {
        min: {
            type: [Number, String],
            default: 20,
        },
        max: {
            type: [Number, String],
            default: 1000,
        },
        step: {
            type: [Number, String],
            default: 10,
        },
        val: {
            type: [Number, String],
            default: 20,
        },
    },
    computed: {
        values() {
            return {
                value: +this.val,
                min: +this.min,
                max: +this.max,
                step: +this.step
            }
        },
        sliderOpts() {
            const vue = this
            return {
                ...this.values,
                change: function(event, ui) {
                    $("#diskslider").val(ui.value);
                    vue.$emit('slide', ui.value);
                    vue.displayVal = ui.value;
                },
                slide: function( event, ui ) {
                    document.querySelector('#i-value').value = ui.value;
                }
            }
        }
    },
    methods: {
        valDown: function() {
            if(this.values.value - 10 < this.values.min) {
                $("#diskslider").val(this.values.min);
                $("#i-value").val(this.values.min);
                $("#diskslider").slider("value", this.values.min);
                this.$emit('slide', this.values.min);
            } else {
                $("#diskslider").val(this.values.value - 10);
                $("#i-value").val(this.values.value - 10);
                $("#diskslider").slider("value", this.values.value - 10);
                this.$emit('slide', this.values.value - 10);
            }
        },
        valUp: function() {
            if(this.values.value + 10 > this.values.max) {
                $("#diskslider").val(this.values.max);
                $("#i-value").val(this.values.max);
                $("#diskslider").slider("value", this.values.max);
                this.$emit('slide', this.values.max);
            } else {
                $("#diskslider").val(this.values.value + 10);
                $("#i-value").val(this.values.value + 10);
                $("#diskslider").slider("value", this.values.value + 10);
                this.$emit('slide', this.values.value + 10);
            }
        }
    },
    mounted() {
        $("#diskslider").slider(this.sliderOpts);
        let inputBox = document.querySelector('#i-value');
        inputBox.value = this.val;
        this.$emit('created', this.val);

        inputBox.addEventListener('change', (ev) => {
            console.log(ev.target.value);
            let sanitisedValue = null;
            function formatInput(val, step){
                if((val % step) == 0){
                    return val;
                } else {
                    // Always round up to the nearest higher multiple of step
                    return Math.ceil(val / step) * step;
                }
            }

            sanitisedValue = formatInput(ev.target.value, 10);

            if (sanitisedValue > this.values.max){
                sanitisedValue = this.values.max;
            } else if (sanitisedValue < this.values.min){
                sanitisedValue = this.values.min;
            }

            $("#diskslider").val(sanitisedValue);
            $("#diskslider").slider("value", sanitisedValue);
            this.sliderOpts.value = sanitisedValue;
            this.displayVal = sanitisedValue;
            this.$emit('slide', sanitisedValue);
            inputBox.value = sanitisedValue;
            console.log(this.displayVal);
        });

        //let html = `<span class="progress-text"></span>`;
        //console.log(document.querySelector('.ui-slider-handle'));
        //document.querySelector('.ui-slider-handle').insertAdjacentHTML('afterbegin', html);
        // if(this.sliderOpts.value === 1) {
        //     document.getElementById('diskslider').classList.add('slider-leftmost');
        // } else if(this.sliderOpts.value === this.cloudServers.length) {
        //     document.getElementById('diskslider').classList.add('slider-rightmost');
        // }
    }
})
